const categories = [
  'cartao-de-credito',
  'economia-domestica',
  'bancos',
  'emprestimo',
  'score',
  'conta-digital',
  'investimentos',
  'renda-extra',
  'foregon',
  'seguro',
  'consorcio',
  'financiamento',
  'pesquisas-de-mercado',
  'protecao-de-dados',
]

const isInvalid = ({ parameters }) => {
  if (Object.keys(parameters).length === 0) return false
  return !categories.includes(parameters.slug)
}

export default { isInvalid }
